import { Api } from 'models/services/api';
import { DeleteCentralKitchenQuery } from 'models/services/graphql';

import { CentralKitchenData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteCentralKitchen($id: ID!) {
    ${DeleteCentralKitchenQuery}
  }
`;

type ResponseData = {
  data: {
    deleteCentralKitchen: CentralKitchenData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: CentralKitchenData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteCentralKitchen;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };